import { getCookieValue } from "../../../cookieHelper";
import { termsOfUse } from "../../../globalConstants";

export const openTermsWindow = () => {
    const uLang = getCookieValue("ulang");
    let lang = termsOfUse.find((x: any) => x.key === uLang);
    let termsUrl: any = process.env.REACT_APP_TERMS_OF_SERVICE;
    if (lang?.val) termsUrl = `${process.env.REACT_APP_LEARNSHIP_BASE_URL}${lang?.val}/termsofuse`
    window.open(termsUrl);
}